import Vue from 'vue'
import VueRouter from 'vue-router'

import authRouter from './authRouter'
import businessSettingRouter from './businessSettingRouter'
import sliderRouter from './sliderRouter'
import usersRouter from './usersRouter'
import roleRouter from './roleRouter'
import categoryRouter from './categoryRouter'
import subCategoryRouter from './subCategoryRouter'
import childCategoryRouter from './childCategoryRouter'
import productRouter from './productRouter'
import customerRouter from './customerRouter'
import orderRouter from './orderRouter'
import mediaRouter from './mediaRouter'
import orderExportRouter from './orderExportRouter'
import fbPixelRouter from './fbPixelRouter'
import facebookPixelRouter from './facebookPixelRouter'
import masterSettingRouter from './masterSettingRouter'
import { DASHBOARD_ACCESS } from "@/helpers/permissionsConstant"

// ?? ADD THIS
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { path: '/', redirect: { name: 'admin-dashboard' } },
    ...authRouter,
    ...usersRouter,
    ...roleRouter,
    ...categoryRouter,
    ...subCategoryRouter,
    ...childCategoryRouter,
    ...productRouter,
    ...sliderRouter,
    ...customerRouter,
    ...orderRouter,
    ...orderExportRouter,
    ...mediaRouter,
    ...fbPixelRouter,
    ...facebookPixelRouter,
    ...masterSettingRouter,
    ...businessSettingRouter,
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/admin/AdminDashboardView.vue'),
      meta: {
        pageTitle: 'Dashboard',
        gate: DASHBOARD_ACCESS,
        breadcrumb: [{ text: 'Dashboard', active: true }]
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: { layout: 'full' },
    },
    { path: '*', redirect: '/error-404' },
  ],
})

// --- FINAL FIXED GUARD ---
router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem('accessToken')
  const isLoggedIn = !!accessToken

  if (to.path.startsWith('/admin') && !isLoggedIn) {
    return next({ name: 'login' })
  }

  if (to.name === 'login' && isLoggedIn) {
    return next({ name: 'admin-dashboard' })
  }

  return next()
})


// ?????? ADD THIS BLOCK (MAIN FIX)
router.afterEach(() => {
  // Force remove overlay spinner
  store.commit('app/TOGGLE_OVERLAY', false)
})


export default router